import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IType } from '../../../models/evaluation.model'
import { doCreateType } from '../../../store/convert.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/program/convert/Editor';
import { successVariant, warningVariant, errorVariant } from '../../../lib/barVariant';
import SimpleHeader from '../../../components/layout/SimpleHeader';

const ProgramConvertCreate: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.convert);

  const onSubmit = async (req: IType) => {
    const res = await dispatch(doCreateType(req));

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create1'), successVariant);
        history.push(`/program/convert`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.convert.title2')}
      />
      <Editor
        type={null}
        onSubmit={onSubmit}
      />
    </div>
  )
}

export default ProgramConvertCreate;
